import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalUtcDateService {

  constructor() { }
   convertLocalToUTC(dateString: any): string {
    // Create a Date object from the input date string
    let localDate = new Date(dateString);
  
    // Adjust the time to UTC, keeping the same local date and time
    // let utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(),
    //                                 localDate.getHours(), localDate.getMinutes(), localDate.getSeconds()));
    let utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), 0, 0, 0, 0));
  
    // Return the date in ISO 8601 format (UTC)
    return utcDate.toISOString();
  }
}
